import {
    FETCH_ALL_HEALTH_PARTNER_SUCCESS, EDIT_HEALTH_PARTNER, UPDATE_HEALTH_PARTNER_SUCCESS, CREATE_HEALTH_PARTNER_SUCCESS, DELETE_HEALTH_PARTNER_SUCCESS,SET_HEALTH_PARTNER
} from "constants/health_partners.constants";

const INIT_STATE = {
    health_partners: [],
    health_partner: {
        id: 0,
        name: '',
        country_id: 0,
        email: '',
        phone_no: '',
        address: "",
        standard_fee: 0,
        express_fee:0,
        health_partner_type_id:0,
        country:null
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        //start health_partner
        case SET_HEALTH_PARTNER: {
            let c = Object.assign({}, state.health_partner);
            c[action.key] = action.value
            return {
                ...state,
                health_partner: c
            }
        }
        case FETCH_ALL_HEALTH_PARTNER_SUCCESS: {
            return {
                ...state,
                health_partners: action.payload.data
            }
        }

        case UPDATE_HEALTH_PARTNER_SUCCESS: {
            let foundIndex = state.health_partners.findIndex(x => x.id === action.payload.data.id);
            let all = Object.assign([], state.health_partners);
            let o =  action.payload.data
            o.country_id = o.country.id
            o.health_partner_type_id = o.partner_type.id
            all[foundIndex] = o
            return {
                ...state,
                health_partners: all,
                health_partner: onanimationiteration
            }
        }

        case CREATE_HEALTH_PARTNER_SUCCESS: {
            let all = Object.assign([], state.health_partners);
            all.push(action.payload.data)
            return {
                ...state,
                health_partners: all,
                health_partner: INIT_STATE.health_partner
            }
        }

        case DELETE_HEALTH_PARTNER_SUCCESS: {
            let all = Object.assign([], state.health_partners);
            let newArray = all.filter(function (c) {
                return c.id !== action.payload.id
            });
            return {
                ...state,
                health_partners: newArray,
            }
        }

        case EDIT_HEALTH_PARTNER: {
            let o = Object.assign({}, state.health_partners.find(c => c.id === action.payload))
            o.country_id = o.country.id
            o.health_partner_type_id = o.partner_type.id
            return {
                ...state,
                health_partner: o
            }
        }

        
        default:
            return state;
    }
}